export default {
    //API_ENDPOINT: 'http://localhost:8000/api',
    API_ENDPOINT: 'https://aqueous-peak-74784.herokuapp.com/api',
  }